import React from "react";
import { useTranslation } from "react-i18next";
import { PromotionPhase } from "@data-types/sport-stats/SportStatsTypes";
import { getTeamStandingsPromotionClass } from "@utils/statistics/utils-statistics";

export const TeamStandingRules = ({
	promotions,
}: {
	promotions?: { name: string; phase: PromotionPhase }[];
}) => {
	const { t } = useTranslation();

	if (promotions?.length == 0) return null;

	return (
		<div className="card card--sectioned card--sunken card--sunken--framed">
			<div className="card__header card--sectioned__header u-pad--bottom--reset">
				<div className="card__title u-type--base u-type--wgt--regular u-mar--left--xtny">
					{t("EVENT.STATISTICS.TEAM_STANDINGS.LEGEND")}
				</div>
			</div>

			<div className="card__body card--sectioned__body u-padd--bottom--2">
				{promotions?.map(({ name, phase }) => (
					<div
						key={phase}
						className="u-mar--bottom--3 u-type--xsml u-color--text--secondary"
					>
						<span
							className={
								"tag tag--spot tag--spot--xtny tag--spot--" +
								getTeamStandingsPromotionClass(phase) +
								" u-mar--right--3 u-mar--left--xsml"
							}
						/>

						<span className="u-align--v--middle">{name}</span>
					</div>
				))}
			</div>
		</div>
	);
};
